import { render, staticRenderFns } from "./CreateNewButton.vue?vue&type=template&id=411e905e&scoped=true"
import script from "./CreateNewButton.vue?vue&type=script&lang=js"
export * from "./CreateNewButton.vue?vue&type=script&lang=js"
import style0 from "./CreateNewButton.vue?vue&type=style&index=0&id=411e905e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411e905e",
  null
  
)

export default component.exports